import CardService from '../services/card.service'

export const cardModule = {
  namespaced: true,

  state: {
    cards: [],
    cardDetail: null,
    card: null,
    criterias: null,
    invalidData: null
  },

  actions: {
    async list ({ commit }) {
      return CardService.list().then(
        response => {
          const cards = response.data
          commit('listSuccess', cards)
          return Promise.resolve(cards)
        },
        error => {
          commit('listFailure')
          return Promise.reject(error)
        }
      )
    },

    async search ({ commit }, criterias) {
      return CardService.search(criterias).then(
        response => {
          const cards = response.data.cards
          commit('searchSuccess', cards)
          return Promise.resolve(cards)
        },
        error => {
          const cards = error.response.data.cards
          if (error.response.data.errorCode === 'EXCEEDED_DISPLAY_LIMIT') {
            commit('searchSuccess', cards)
          } else {
            commit('searchFailure')
          }
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async reset ({ commit }) {
      commit('listReset')
    },

    async setCard ({ commit }, card) {
      commit('cardSuccess', card)
    },

    async getDetail ({ commit }, criterias) {
      return CardService.getDetail(criterias).then(
        response => {
          const cardDetail = response.data.cardDetail
          commit('detailSuccess', cardDetail)
          return Promise.resolve(cardDetail)
        },
        error => {
          commit('detailFailure')
          return Promise.reject(error.response)
        }
      )
    },

    async resetDetail ({ commit }) {
      commit('detailReset')
    },

    async unmaskPan ({ commit }, criterias) {
      return CardService.unmaskPan(criterias).then(
        response => {
          const unmaskedPanImg = 'data:image/jpg;base64,' + response.data.panCard
          return Promise.resolve(unmaskedPanImg)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async activate ({ commit }, criterias) {
      return CardService.activate(criterias).then(
        response => {
          const cardDetail = response.data.cardDetail
          commit('actionSuccess', cardDetail)
          return Promise.resolve(cardDetail)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async deactivate ({ commit }, criterias) {
      return CardService.deactivate(criterias).then(
        response => {
          const cardDetail = response.data.cardDetail
          commit('actionSuccess', cardDetail)
          return Promise.resolve(cardDetail)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async block ({ commit }, criterias) {
      return CardService.block(criterias).then(
        response => {
          const cardDetail = response.data.cardDetail
          commit('actionSuccess', cardDetail)
          return Promise.resolve(cardDetail)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async unblock ({ commit }, criterias) {
      return CardService.unblock(criterias).then(
        response => {
          const cardDetail = response.data.cardDetail
          commit('actionSuccess', cardDetail)
          return Promise.resolve(cardDetail)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async setCriterias ({ commit }, criterias) {
      commit('setCriterias', criterias)
    },

    async resetCriterias ({ commit }) {
      commit('resetCriterias')
    },

    async invalidData ({ commit }, error) {
      commit('invalidData', error)
    },

    async resetInvalidData ({ commit }) {
      commit('invalidData', null)
    }
  },

  mutations: {
    listSuccess (state, cards) {
      state.cards = cards
    },
    listFailure (state) {
      state.cards = []
    },
    listReset (state) {
      state.cards = []
    },
    searchSuccess (state, cards) {
      state.cards = cards
    },
    searchFailure (state) {
      state.cards = []
    },
    cardSuccess (state, card) {
      state.card = card
    },
    detailSuccess (state, cardDetail) {
      state.cardDetail = cardDetail
    },
    actionSuccess (state, cardDetail) {
      state.cardDetail.enableActionsOnCard = cardDetail.enableActionsOnCard
      state.cardDetail.cardActivable = cardDetail.cardActivable
      state.cardDetail.cardDeactivable = cardDetail.cardDeactivable
      state.cardDetail.cardBlockable = cardDetail.cardBlockable
      state.cardDetail.cardUnBlockable = cardDetail.cardUnBlockable
    },
    detailFailure (state) {
      state.cardDetail = null
    },
    detailReset (state) {
      state.cardDetail = null
    },
    setCriterias (state, criterias) {
      state.criterias = criterias
    },
    resetCriterias (state) {
      state.criterias = null
    },
    invalidData (state, error) {
      state.invalidData = error
    }
  }
}
